var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilhos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 73.4",
    style: {
      enableBackground: "new 0 0 65 73.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9B0008;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.9,46.6c-4.1,0-7.4-3.3-7.4-7.4c0-0.2,0-0.3,0-0.5l1.4-20.1c0-0.6,0.5-1.1,1.2-1.1h7.7 c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1H8.1l-1.3,19c-0.2,2.5,1.5,4.8,4,5.3V29.5c0-0.6,0.5-1.1,1.1-1.1 c0.6,0,1.1,0.5,1.1,1.1v16C13,46.1,12.5,46.6,11.9,46.6C11.9,46.6,11.9,46.6,11.9,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,73.3h-7.5c-0.6,0-1.1-0.5-1.1-1.1V40c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v31h5.2V44.6 c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v27.5C20.5,72.7,20,73.3,19.4,73.3C19.4,73.3,19.4,73.3,19.4,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,15.1c-4.2,0-7.5-3.4-7.5-7.5S15.2,0,19.4,0c4.2,0,7.5,3.4,7.5,7.5c0,0,0,0,0,0 C26.9,11.7,23.5,15.1,19.4,15.1C19.4,15.1,19.4,15.1,19.4,15.1z M19.4,2.3c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3 s5.3-2.4,5.3-5.3S22.3,2.3,19.4,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.2,46.6c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0v-16c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v14.7 c2.5-0.5,4.2-2.8,4-5.3l-1.3-19h-6.7c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1H58c0.6,0,1.1,0.5,1.1,1.1l1.4,20.1 c0.3,4.1-2.8,7.6-6.9,7.9C53.5,46.6,53.3,46.6,53.2,46.6L53.2,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.2,73.3h-7.5c-0.6,0-1.1-0.5-1.1-1.1V44.6c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1V71H52V40 c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v32.1C54.3,72.7,53.8,73.3,53.2,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.3,20H25.8c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1l0,0h13.5c0.6,0,1.1,0.5,1.1,1.1 C40.4,19.5,39.9,20,39.3,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,15.1c-4.2,0-7.5-3.4-7.5-7.5c0-4.2,3.4-7.5,7.5-7.5s7.5,3.4,7.5,7.5c0,0,0,0,0,0 C53.2,11.7,49.8,15,45.6,15.1z M45.6,2.3c-2.9,0-5.3,2.3-5.3,5.2c0,2.9,2.3,5.3,5.2,5.3s5.3-2.3,5.3-5.2c0,0,0,0,0,0 C50.9,4.6,48.5,2.3,45.6,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.9,73.4H1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h62.7c0.6,0,1.1,0.5,1.1,1.1 C65,72.9,64.5,73.4,63.9,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.5,73.3c-0.6,0-1.1-0.5-1.1-1.1V58.8c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v13.4 C33.6,72.7,33.1,73.3,32.5,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.6,57c-0.6,0-1.1-0.5-1.1-1.2v-9.6c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v9.6 C28.7,56.4,28.2,57,27.6,57C27.6,57,27.6,57,27.6,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.5,73.3h-4.9c-0.6,0-1.1-0.5-1.1-1.1V55.8c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1V71h3.8 c0.6,0,1.1,0.5,1.1,1.1C33.6,72.8,33.1,73.3,32.5,73.3L32.5,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.4,73.3h-4.9c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h3.8V55.8c0-0.6,0.5-1.1,1.1-1.1 c0.6,0,1.1,0.5,1.1,1.1v16.3C38.6,72.7,38.1,73.3,37.4,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.4,57c-0.6,0-1.1-0.5-1.1-1.2v-9.6c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v8.2 c0.4-0.2,0.7-0.4,1-0.7c0.6-0.6,0.9-1.4,0.8-2.2l-0.6-10.9H25.2l-0.6,10.9c-0.1,1.7,1.2,3.1,2.9,3.1c0,0,0.1,0,0.1,0 c0.6,0.1,1.1,0.6,1,1.3c-0.1,0.6-0.5,1-1,1c-2.9,0-5.2-2.4-5.2-5.3c0-0.1,0-0.2,0-0.3L23,40.3c0.1-1.1,0.9-1.9,2-1.9h15 c1.1,0,1.9,0.9,2,1.9l0.6,11.1c0.2,2.9-2,5.4-4.9,5.6C37.6,57,37.5,57,37.4,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.4,55.6h-9.9c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0h9.9c0.6,0,1.1,0.5,1.1,1.1 S38.1,55.6,37.4,55.6C37.4,55.6,37.4,55.6,37.4,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.5,36.5c-2.8,0-5.1-2.3-5.1-5.1c0-2.8,2.3-5.1,5.1-5.1c2.8,0,5.1,2.3,5.1,5.1 C37.6,34.2,35.3,36.5,32.5,36.5z M32.5,28.7c-1.5,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8c1.5,0,2.8-1.2,2.8-2.8l0,0 C35.3,29.9,34,28.7,32.5,28.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilhos);
export default __webpack_public_path__ + "static/media/filhos.032453fec243e648c0e6b9467f3afc91.svg";
export { ForwardRef as ReactComponent };